import React, { Component } from "react";
import PropTypes from "prop-types";
import { List, ListItem, ListItemText, withStyles } from "@material-ui/core";
import { DragSource } from "react-dnd";
import WBToolbar from "./WBToolbar";

export const dndType = "listItemType";

const styles = theme => ({
  List: {
    overflow: "auto",
    height: 500,
    paddingTop: 0,
    paddingBottom: 0
  },
  ListItem: {
    paddingTop: 0,
    paddingBottom: 0
  }
});

const externalNodeSpec = {
  beginDrag: componentProps => ({ node: { ...componentProps.node } })
};

const externalNodeCollect = connect => ({
  connectDragSource: connect.dragSource()
});

class externalNodeBaseComponent extends Component {
  render() {
    const { connectDragSource, node } = this.props;

    return connectDragSource(<div>{node.name}</div>, { dropEffect: "copy" });
  }
}

externalNodeBaseComponent.propTypes = {
  node: PropTypes.shape({ id: PropTypes.number, name: PropTypes.string })
    .isRequired,
  connectDragSource: PropTypes.func.isRequired
};
const NodeComponent = DragSource(
  dndType,
  externalNodeSpec,
  externalNodeCollect
)(externalNodeBaseComponent);

export const DragSourceListMode = Object.freeze({
  READ: Symbol("read"),
  EDIT: Symbol("edit")
});

class DragSourceList extends Component {
  state = {
    filterText: ""
  };

  getMode = () => {
    let { dragSourceListMode } = this.props;
    if (!dragSourceListMode) {
      dragSourceListMode = DragSourceListMode.EDIT;
    }
    return dragSourceListMode;
  };

  render() {
    const { accounts, classes } = this.props;
    const dragSourceListMode = this.getMode();

    let filteredAccounts = accounts;
    if (this.state.filterText) {
      filteredAccounts = accounts.filter(a => {
        return (
          a.name.toLowerCase().includes(this.state.filterText.toLowerCase()) ||
          (a.number &&
            a.number
              .toLowerCase()
              .includes(this.state.filterText.toLowerCase()))
        );
      });
    }

    return (
      <div>
        <WBToolbar
          onFilter={filterText => {
            this.setState({ filterText: filterText });
          }}
        />
        <hr style={{ margin: 2 }} />
        <div>
          <List className={classes.List}>
            {filteredAccounts.map(account => (
              <ListItem button key={account.id} className={classes.ListItem}>
                <ListItemText component="subheading">
                  {dragSourceListMode === DragSourceListMode.EDIT ? (
                    <NodeComponent
                      key={account.id}
                      node={{
                        id: account.id,
                        name: account.number
                          ? `${account.number} - ${account.name}`
                          : account.name,
                        type: "itemDrop"
                      }}
                    />
                  ) : account.number ? (
                    `${account.number} - ${account.name}`
                  ) : (
                    account.name
                  )}
                </ListItemText>
              </ListItem>
            ))}
          </List>{" "}
        </div>
      </div>
    );
  }
}

DragSourceList.propTypes = {
  accounts: PropTypes.array.isRequired
};

export default withStyles(styles)(DragSourceList);
